const currentUrl = window.location.href
export const apiURL = currentUrl.includes('local') ? 'http://178.156.133.97:30872/center369' : '/center369'
export const agentVerifyURL = 'https://integrationsdevelopment.cgicapi.com/agent/v1-1/agent_signin'

// const currentUrl = window.location.href
// export const apiURL = currentUrl.includes('local')
//   ? 'https://lifeeapp-dtc-test.afficiency.com/api/center369'
//   : '/center369'

export const prsCodes = {
  getAffiliateDashInfo: '3702K702',
  getAgentProducts: '3702T702',
  login: '3702B702',
  loginWithOtp: '3702702B',
  getApps: '3702P702',
  getAppsV2: '3702702J',
  getAppsV3: '3702703J',
  getMetrics: '3702O702',
  getMetricsV2: '3702O703',
  getMetricsV3: '3702O704',
  getFactTableApps: '3702Q702',
  getFactTableAppsV2: '3702Q703',
  getQuilityApps: '3702702D',
  getAgentList: '3702X702',
  req90DaysChange: '3702702K',
  createAccount: '3702E702',
  createAccountV3: '3702E802',
  createAffiliateCode: '3702702X',
  agentVerifyV3: '3702Q704',
  getProducerProfile: '3702F803',
  getAgentCommissions: '3702G804',
}
